import React from 'react';
import Step from "components/MainApp/atoms/Wizard/Step";
import MainInput from "components/MainApp/atoms/Forms/MainInput";
import MainDropdownInput from "components/MainApp/atoms/Forms/MainDropdown";


import styles from "./Step1.module.scss";
import i18n from 'i18n';

export class AddDeviceStepOne extends React.Component {
  render() {
    const { device, handleSelect, handleContinue, types, enableContinue, error, device_types_child } = this.props;

    const stepContent = (
      <form onSubmit={handleContinue}>
      <div className={styles["add-device-wizard-step-one-content"]}>

        <div className={styles["add-device-wizard-step-one-field"]} data-automation-id="input-types">
          <MainDropdownInput
            required={true}
            id={"device-type"}
            name="type"
            selectedOption={device ? device.type : ''}
            handleSelection={(selectedOption) => handleSelect(selectedOption, 'type')}
            maxLength={50}
            options={types}
            placeholder={i18n.t("select")}
            label={i18n.t("select")}
            error={error.type && error.type}
          />
        </div>

        <div className={styles["add-device-wizard-step-one-field"]} data-automation-id="input-types" style={{ display: device_types_child.length ? "block" : "none" }}>
          <MainDropdownInput
            required={true}
            id={"device-type-child"}
            name="device-type-child"
            selectedOption={device ? device.device_type : ''}
            handleSelection={(selectedOption) => handleSelect(selectedOption, 'device_type')}
            maxLength={50}
            options={device_types_child}
            placeholder={i18n.t("select")}
            label={i18n.t("select")}
            error={error.type && error.type}
          />
        </div>

        <div className={styles["add-device-wizard-step-one-action-wrapper"]}>
          <button type="submit" className={`${styles["add-device-wizard-step-one-action-button"]} ${!enableContinue ? styles["disabled"] : ""}`} onClick={enableContinue ? handleContinue : undefined} >
            {i18n.t("continue").toUpperCase()}
          </button>
        </div>
      </div>
      </form>
    );

    return (
      <div className={styles["add-device-wizard-step-one-container"]}>
        <Step title={i18n.t("select.device.type")} content={stepContent} paddingVariant="device-padding"></Step>
      </div>
    );
  }
}

export default AddDeviceStepOne;
